import './src/styles/global.css';

export const onClientEntry = () => {
  const urlQuery = new URLSearchParams(window.location.search);
  let source = urlQuery.get('utm_source');
  let reference = urlQuery.get('utm_trackingId');
  if (source && reference) {
    window.__source = window.localStorage.setItem('source', source);
    window.__reference = window.localStorage.setItem('reference', reference);
  }
};

// The application form is switched off while Familio originates no new loans.
// Remove any form script or stylesheet that may still be present on a page.
export const onRouteUpdate = () => {
  document
    .querySelectorAll('[src^="https://app.familio.co.uk"]')
    .forEach(el => el.remove());
  document
    .querySelectorAll('[href^="https://app.familio.co.uk"]')
    .forEach(el => el.remove());
};
